var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import render from 'utils/render';
const SvgAsacp = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    ...props
  } = _ref;
  const Element = render.element(/*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.74 12",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "be422885-4637-4952-ba63-8f82dd91f263",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a0b7024b-79f2-47de-b095-c31f5346aec2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aa38732a-cefc-4198-9501-1ecc5029b2fb",
    "data-name": "ASACP",
    d: "M6,3.23,7.26,7.37H4.94Zm21.12,0,1.24,4.14H26.07Zm21.6-.65H50.2a1.33,1.33,0,0,1,1.3,1.35,1.33,1.33,0,0,1-1.3,1.35H48.74ZM4.31.2,0,11.83H3.54l.61-1.91H8L8.79,12h8.63s2.53-.17,3.4-2.08a3.74,3.74,0,0,0-.93-4.63A10.2,10.2,0,0,0,16.49,4c-1.27-.35-1.69-.27-1.69-1s.78-.79.78-.79h9.09l-3.54,9.57h3.54l.61-1.92h3.86l.61,1.92H40.08A3.68,3.68,0,0,0,43,10.07c.84-1.66.77-2.08.77-2.08L40.69,7s-.09,2.23-2,2.23a2.13,2.13,0,0,1-2.32-1.91,5.9,5.9,0,0,1,.16-2.88,2.29,2.29,0,0,1,1.69-1.75h7.1V11.8H48.7V7.49h2.63S54.64,7,54.72,4.78s-.18-2.48-.47-3A3.42,3.42,0,0,0,51.94.15H36.67a5.06,5.06,0,0,0-3.7,4,9,9,0,0,0,.61,5.26H32.34L29,0H15.58s-4.17.18-4,3.35S14.7,6.61,15.74,7s2.15.56,2.15,1.43A1.08,1.08,0,0,1,17,9.55H11.57L8,.15H4.31Z"
  }))))));
  return /*#__PURE__*/React.createElement(Element.type, _extends({}, Element.props, {
    ref: ref
  }), children, Element.props.children);
});
export default /*#__PURE__*/React.memo(SvgAsacp);